export default __webpack_public_path__ + "static/media/111.bfdc5681.webp";